import { createSelector, createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,
  blockContent: {
    items: [],
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
  },
  blockDesign: {
    view: 'feed',
    layout: '1',
  },
  itemDesign: {},
  containerDesign: {},
};

export const timetableSlice = createSlice({
  name: 'timetable',
  initialState,
  reducers: {
    timetableStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;
      const block = data ?? {};
      const { blockContent, blockDesign } = block;
      const { itemDesign, containerDesign } = blockDesign;

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.itemDesign = itemDesign ?? {};
      state.containerDesign = containerDesign ?? {};

      state.blockContent = {
        items: blockContent.items ?? [],
        heading: {
          title: blockContent.heading?.title ?? '',
          description: blockContent.heading?.description ?? '',
          textAlign: blockContent.heading?.textAlign ?? 'left',
          image: blockContent.heading?.image ?? '',
          divider: blockContent.heading?.divider ?? '',
          position: blockContent.heading?.position ?? '',
        },
      };

      state.blockDesign = {
        view: blockDesign.view ?? 'feed',
        layout: blockDesign.layout ?? '1',
      };
    },
    timetableClear: () => initialState,
    timetableUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    timetableUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    timetableUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
    timetableUpdateBlockDesign: (state, action) => {
      state.blockDesign = action.payload;
    },
  },
});

export const { timetableStore, timetableClear, timetableUpdateIsLoading, timetableUpdateIsActive, timetableUpdateBlockContent, timetableUpdateBlockDesign } = timetableSlice.actions;

export const selectTimetableIsLoading = (state) => state.timetable.isLoading;
export const selectTimetableId = (state) => state.timetable.id;
export const selectTimetableUID = (state) => state.timetable.uid;
export const selectTimetableSID = (state) => state.timetable.sid;
export const selectTimetableBlockContent = (state) => state.timetable.blockContent;
export const selectTimetableBlockDesign = (state) => state.timetable.blockDesign;
export const selectTimetableSortItems = createSelector([selectTimetableBlockContent], ({ items }) => items ?? []);
export const selectTimetableItemDesign = (state) => state.timetable.itemDesign;
export const selectTimetableContainerDesign = (state) => state.timetable.containerDesign;

export default timetableSlice.reducer;
